import { CardComponentProps } from "@~/types/types";
import styles from "./QuantityPurchased.module.scss";
import { VIEW_GIFT_MESSAGES } from "@~/utils/events.ts";
import { useVariant } from "@~/contexts/VariantContext/VariantContext.tsx";
import { useEffect, useState } from "react";
import { EVENTS } from "@~/product-card-components/__shared__/AddToBasketUtils/basketEvents.ts";

type ATWEvent = {
  variantId?: string;
  skuId?: string;
  quantity?: number;
  errorMessage?: string;
};

export function QuantityPurchased({
  product,
}: Pick<CardComponentProps, "product">) {
  const { variant } = useVariant();
  const [productQuantityWanted, setProductQuantityWanted] = useState<
    number | undefined
  >(product.wanted);

  useEffect(() => {
    window.addEventListener(
      EVENTS.JL_EVENTS_WISHLIST_QUANTITY_UPDATED,
      function onSuccess(e: Event) {
        const detail = (e as CustomEvent<ATWEvent>).detail;
        if (detail.skuId !== variant?.aliases?.skuId) return;
        setProductQuantityWanted(detail.quantity);
      },
    );

    return () => {
      window.removeEventListener(
        EVENTS.JL_EVENTS_WISHLIST_QUANTITY_UPDATED,
        () => {},
      );
    };
  }, [variant]);

  if (product.wanted === undefined) {
    return null;
  }
  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent(VIEW_GIFT_MESSAGES, {
        detail: {
          pimProductId: product.aliases.pimProductId,
          skuId: variant?.aliases?.skuId,
        },
      }),
    );
  };

  return (
    <div
      className={styles.purchasedIndicator}
      data-component="pcl-QuantityPurchased"
      onClick={handleClick}
    >
      <h2 className={styles.title}>
        {product.purchased || 0} of {productQuantityWanted} purchased
      </h2>
    </div>
  );
}
